import React, {Component} from 'react';

import Options from './drop-down/options.js';
import HelpLinks from '../help-links.js';

export default class DropDown extends Component {

  constructor(props) {
    super(props);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleLabelChange = this.handleLabelChange.bind(this);
    this.handleDeleteCustomisation = this.handleDeleteCustomisation.bind(this);
    this.helpLinks = new HelpLinks('drop-down');
  }

  handleNameChange(e) {
    this.props.changeName(this.props.customisation.index, e.target.value);
  }

  handleLabelChange(e) {
    this.props.changeLabel(this.props.customisation.index, e.target.value);
  }

  handleDeleteCustomisation() {
    this.props.deleteCustomisation(this.props.customisation.index);
  }

  render() {
    return (
      <section className="DropDown customisation">
        <h3 className="DropDown__type">VARIATION TYPE: Drop down</h3>
        <div>
          <span>
            <label>Label:</label>
            <input
              className="DropDown__name"
              value={this.props.customisation.name}
              onChange={this.handleNameChange}
              placeholder="Eg. 'Colour scheme'"
            />
          </span>
          <p className="hint">
            This will be the label for your drop-down option.
            &nbsp;
            {this.helpLinks.linkFor('label')}
          </p>
        </div>
        <div>
          <span>
            <label>Description:</label>
            <input
              className="DropDown__label"
              value={this.props.customisation.label}
              onChange={this.handleLabelChange}
              placeholder="Eg. 'Please select a colour scheme'"
            />
          </span>
          <p className="hint">
            This text describes the options available.
            &nbsp;
            {this.helpLinks.linkFor('description')}
          </p>
        </div>
        <Options
          customisationIndex={this.props.customisation.index}
          options={this.props.customisation.options}
          addNewDropDownOption={this.props.addNewDropDownOption}
          deleteDropDownOption={this.props.deleteDropDownOption}
          changeOptionValue={this.props.changeOptionValue}
          changeOptionPrice={this.props.changeOptionPrice}
          helpLinks={this.helpLinks}
        />
        <div className="ui-options">
          <button
            className="DropDown__delete del"
            onClick={(e) => {
              if (window.confirm('Are you sure you want to delete this variation?')) {
                this.handleDeleteCustomisation(e);
              }
            }}
          >&times; Delete</button>
        </div>
      </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/item-customisations/fields/drop-down.js